import { useTranslation } from "react-i18next";
import { Video } from "lucide-react";
import { Button, Card } from "@tellescope/design-system";
import type { CalendarEvent } from "@tellescope/types-models";
import { useJoinVideoCall } from "../hooks/useJoinVideoCall";
import { useEventStatus } from "../hooks/useEventStatus";
import { useEnduserStore } from "../store";

interface VideoCallJoinCardProps {
  event: CalendarEvent;
}

export const VideoCallJoinCard = ({ event }: VideoCallJoinCardProps) => {
  const { t } = useTranslation("videoCalling");
  const currentEnduser = useEnduserStore((state) => state.currentEnduser);
  const { joinVideoCall } = useJoinVideoCall();
  const { isMeetingLive, canJoinVideo } = useEventStatus(event, currentEnduser);

  return (
    <Card variant="floating" padding="root" className="max-w-md w-full mx-4">
      <Card.Body className="p-6 text-center">
        <Video className="h-12 w-12 mx-auto mb-4 text-primary" />
        <h1 className="text-xl font-semibold mb-2">{event.displayTitle || event.title}</h1>
        {canJoinVideo && (
          <p className="text-sm text-muted-foreground mb-6">
            {isMeetingLive
              ? t("Ready to join your video appointment")
              : t("You'll be connected automatically when your provider starts the call.")}
          </p>
        )}
        <Button className="w-full h-12" onClick={() => joinVideoCall(event)} disabled={!canJoinVideo}>
          <Video className="h-5 w-5 mr-2" />
          {t("Join Video Call")}
        </Button>
      </Card.Body>
    </Card>
  );
};
